import { useLoadingStore, selectLoading } from '@/modules/shared/stores/loadingStore'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { TextField } from '@/ui/form/controls/TextField'
import * as React from 'react'

const AddGroupsForm = ({ setNewGroupName, newGroupName, defaulValue = '' }) => {
  const { t } = useLocalize()
  const loading = useLoadingStore(selectLoading)
  React.useEffect(() => {
    if (defaulValue && !newGroupName) {
      setNewGroupName(defaulValue)
    }
  }, [])

  return (
    <div className="tw-p-4 tw-pt-0">
      <TextField
        disabled={loading}
        label={t('groups.group-name')}
        required
        placeholder={t('groups.enter-group-name')}
        value={newGroupName}
        onChange={(e) => setNewGroupName(e.target.value)}
      />
    </div>
  )
}

export default AddGroupsForm
